import React from 'react';
import OiButton from '../Common/OiButton/OiButton';
import Modal from './modal';

const DeleteModal = ({ modalVisibility, onModalChange, loading, handleConfirm, confirmationMessage }) => {
    return (
        <Modal modalVisibility={modalVisibility} onModalChange={onModalChange}>
            <div className="u-font14sb">{confirmationMessage}</div>
            <div className="oi-transact-info__actions">
                <div>
                    <OiButton
                        onClick={onModalChange}
                        styles="oi-btn oi-btn--primary u-pady_08 u-pady_020 oi-btn--radius5 oi-btn--height30 | u-font12md u-mxr-09 u-myt-08">
                        Cancel
                    </OiButton>

                    <OiButton
                        styles="oi-btn oi-btn--tertiary u-pady_08 u-pady_020 oi-btn--radius5 oi-btn--height30 | u-font12md u-mxr-09 u-myt-08"
                        buttonLoader={loading}
                        onClick={handleConfirm}>
                        Delete
                    </OiButton>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteModal;
